import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import { Heading, Text, Absolute, Measure, Box } from 'rebass'

import Globe from '../components/Globe'
import { HTMLContent } from '../components/Content'

const MQAbsolute = styled(Absolute)`
  @media screen and (max-width: 60rem) {
    position: static;
    margin: 2rem;
  }

  @media screen and (max-width: 30rem) {
    h2 {
      font-size: 1.25rem;
    }
  }
`

const StyledLink = styled(Link)`
  display: block;
  white-space: nowrap;
  cursor: pointer;
  color: white;
  margin-top: 2rem;
  text-decoration: underline;
  &:disabled {
    opacity: 0.25;
  }
`

export default class IndexPage extends React.Component {
  render() {
    return (
      <MQAbsolute top={'3rem'} left={'3rem'} zIndex={10}>
        <Measure maxWidth={'48em'}>
          {/*<Heading
            fontSize={7}
            fontWeight={300}
            lineHeight={1.1}
            color="white"
            style={{ textShadow: '0 0 1.5rem rgba(0,0,0,0.5)' }}
          >
            To propel a movement for collaborative green cities
          </Heading>
          <StyledLink to="/globe">Learn More</StyledLink> */}
          <HTMLContent
            location={this.props.location.pathname}
            content={
              this.props.language === 'french'
                ? this.props.data.page.acf.french_content
                : this.props.data.page.content
            }
          />
        </Measure>
      </MQAbsolute>
    )
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    dataJson {
      id
      coords
    }
    page: wordpressPage(id: { eq: "6717c4a3-2d93-5945-9c2d-7ae76d998ef9" }) {
      content
      acf {
        french_content
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js